export const utilityTypes = ['Electricity', 'Water / sewerage', 'Gas', 'Heat / cooling', 'Telecoms / data', 'Other'];
export const utilityTariffStates = ['Unknown', 'Contracted', 'Deemed', 'Under review', 'Not applicable'];
export const utilityTransferStates = ['Unknown', 'Not started', 'Requested', 'In progress', 'Transferred', 'Not applicable'];
export function utilitySupplyGaps(facts, opening) {
    const missing = [];
    if (facts.outstandingInformation.trim())
        missing.push('Outstanding handover information');
    if (!facts.supplyReference)
        missing.push('Supply or connection reference');
    // C-194: the supplier or operator can follow the opening reading.
    if (['Unknown', 'Under review'].includes(facts.tariffStatus))
        missing.push('Tariff status');
    if (facts.tariffStatus === 'Contracted' && (!facts.contractStart || !facts.contractEnd))
        missing.push('Contract dates');
    if (!['Transferred', 'Not applicable'].includes(facts.transferStatus))
        missing.push('Account transfer');
    if (!facts.responsibility)
        missing.push('Operational responsibility');
    if (['Electricity', 'Water / sewerage', 'Gas', 'Heat / cooling'].includes(facts.utilityType) && !facts.details && !opening?.accepted)
        missing.push('Reviewed opening meter reading');
    if (facts.utilityType === 'Gas' && !facts.emergencyControlLocation)
        missing.push('Emergency control location');
    if (facts.utilityType === 'Telecoms / data' && !facts.credentialOwner)
        missing.push('Credential owner');
    return missing;
}
//# sourceMappingURL=utility-supplies.js.map